import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { useInterstateTheme } from '@interstate/components/InterstateThemeProvider';
import { useHeaderMeasure } from '@makemydeal/dr-dash-components';
import { ScopedStateProvider, scopedStateSelectors } from '@makemydeal/shared-scoped-store';

import { DealCentralContainerCompact, OfferCommentsWrapper } from '../DeskingActivity.styles';
import OfferCommentsInterstate from '../OfferComments.interstate';
import BaseDealHeader from '../baseDealActivity/BaseDealHeader';
import { ManualEditsLegend } from './manualEditsLegend/ManualEditsLegend';
import { usePinnedHeaderOffset } from './hooks/usePinnedHeaderOffset';
import { useScenarioGridRows } from './hooks/useScenarioGridRows';
import { SCENARIO_COLUMN_SECTIONS, ScenarioColumn } from './ScenarioColumn';
import { ScenarioGridRoot, ScenarioScroller } from './ScenarioGrid.style';

export const SCENARIOS_REGION_LABEL = 'Scenarios';

export const ScenarioGridContent = () => {
    const theme = useInterstateTheme();
    const gridRef = useRef<HTMLDivElement>(null);
    const scopesOrder = useSelector(scopedStateSelectors.getScopesOrder);
    const { gridRowKeys, hoverRowKeys } = useScenarioGridRows();
    const headerHeight = useHeaderMeasure()?.height ?? 0;

    usePinnedHeaderOffset(gridRef, headerHeight);

    return (
        <DealCentralContainerCompact>
            <BaseDealHeader />
            <ScenarioScroller theme={theme} role="region" aria-label={SCENARIOS_REGION_LABEL} tabIndex={0}>
                <ScenarioGridRoot
                    ref={gridRef}
                    theme={theme}
                    $columns={scopesOrder.length}
                    $rowCount={SCENARIO_COLUMN_SECTIONS.length + gridRowKeys.length}
                    $hoverRowKeys={hoverRowKeys}
                    data-testid="scenario-grid"
                >
                    {scopesOrder.map((scopeId: string) => (
                        <ScopedStateProvider scopeId={scopeId} key={scopeId}>
                            <ScenarioColumn scopeId={scopeId} />
                        </ScopedStateProvider>
                    ))}
                </ScenarioGridRoot>
            </ScenarioScroller>
            <ManualEditsLegend />
            <OfferCommentsWrapper>
                <OfferCommentsInterstate title="Offer Comments" textRows={1} />
            </OfferCommentsWrapper>
        </DealCentralContainerCompact>
    );
};
